export const POSTDATAREQUEST = "POSTDATAREQUEST"
export const POSTDATASUCCESS = "POSTDATASUCCESS"
export const POSTDATAFAILURE = "POSTDATAFAILURE"